import React, { useState } from "react";
import WordEditor from "../../../Extra/WordEditor";
import FormInputFormMsg from "./FormInputFormMsg";
const MessagingMaster = () => {
  const [msgData, setMsgData] = useState(null);

  const handleEditorChange = async (data) => {
    setMsgData(data.html);
    //   console.log("HTML:", data.html);
    //     console.log("JSON:", data.json);
    //     console.log("TEXT:", );
  };
  return (
    <div>
      <div className="row m-1">
        <div className="d-flex justify-content-center">
          <div className="text-center">
            <h5>Message Master</h5>
            <span>Module For saving ICMS And FOIS message</span>
          </div>
        </div>
        <hr />
      </div>
      <div className="row  m-2">
        <div className="col-md-6">
          <WordEditor onChange={handleEditorChange} initialContent={""} />
        </div>
        <div className="col-md-6">
          <FormInputFormMsg data={msgData} />
        </div>
      </div>
    </div>
  );
};
export default MessagingMaster;
